export function faqFilter() {
  const select = document.getElementById("js-faq-filter");
  const list = document.getElementById("js-faq-list");
  if (!select || !list) return;

  const groups = list.querySelectorAll("[data-genre]");

  select.addEventListener("change", () => {
    const value = select.value;

    groups.forEach((group) => {
      if (!value || group.dataset.genre === value) {
        group.hidden = false;
      } else {
        group.hidden = true;
      }
    });
  });
}
